import PropTypes from "prop-types";

const Industries_Frame = ({ className = "" }) => {
  return (
    <div className="mt-12">
      <div className="flex justify-center text-15xl font-bold uppercase text-deepskyblue-200">
        <div>INDUSTRIES WE WORK WITH</div>
      </div>

      {/* <div className="absolute top-[0px] left-[0px] w-[649px] h-[316px]">
        <b className="absolute top-[0px] left-[46px] leading-[100%] uppercase inline-block w-[229px] h-[60px]">
          INFORMATION Technology
        </b>
        <b className="absolute top-[17px] left-[436px] leading-[100%] uppercase inline-block w-[147px] h-[52px]">
          BFSI
        </b>
        <b className="absolute top-[145px] left-[36px] leading-[100%] uppercase inline-block text-center w-[211px] h-[30px]">
          Hospitality
        </b>
        <b className="absolute top-[146px] left-[438px] leading-[100%] uppercase inline-block w-[211px] h-[30px]">
          ADVERTISING
        </b>
        <b className="absolute top-[281px] left-[46px] leading-[100%] uppercase inline-block w-[187px] h-[35px]">
          LOGISTICS
        </b>
        <b className="absolute top-[281px] left-[438px] leading-[100%] uppercase inline-block w-[387px] h-[35px]">
          CREDIT RATING
        </b>
        <div className="absolute top-[16px] left-[0px] rounded-[50%] bg-gray-100 w-6 h-6" />
        <div className="absolute top-[145px] left-[0px] rounded-[50%] bg-gray-100 w-6 h-6" />
        <div className="absolute top-[281px] left-[0px] rounded-[50%] bg-gray-100 w-6 h-6" />
        <div className="absolute top-[17px] left-[390px] rounded-[50%] bg-gray-100 w-6 h-6" />
        <div className="absolute top-[146px] left-[390px] rounded-[50%] bg-gray-100 w-6 h-6" />
        <div className="absolute top-[281px] left-[390px] rounded-[50%] bg-gray-100 w-6 h-6" />
      </div> */}

      <div className="flex flex-col lg:flex-row justify-between gap-8 mt-8">
        <div className="flex flex-col sm:flex-row justify-between text-black">
          <ul>
            <li>IT</li>
            {/* <li>BFSI</li> */}
            <li>HOSPITALITY</li>
            {/* <li>ADVERTISING</li> */}
            <li>LOGISTICS</li>
            {/* <li>CREDIT RATING</li> */}
          </ul>

          <ul>
            {/* <li>INFORMATION TECHNOLOGY</li> */}
            <li>BFSI</li>
            {/* <li>HOSPITALITY</li> */}
            <li>ADVERTISING</li>
            {/* <li>LOGISTICS</li> */}
            <li>CREDIT RATING</li>
          </ul>
        </div>

        <img
          className="object-cover w-full lg:w-1/2"
          alt=""
          src="/rectangle-19@2x.png"
        />
      </div>
    </div>
  );
};

Industries_Frame.propTypes = {
  className: PropTypes.string,
};

export default Industries_Frame;
